import { render, staticRenderFns } from "./thank-you.vue?vue&type=template&id=47ffab1d&scoped=true"
import script from "./thank-you.vue?vue&type=script&lang=js"
export * from "./thank-you.vue?vue&type=script&lang=js"
import style0 from "./thank-you.vue?vue&type=style&index=0&id=47ffab1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ffab1d",
  null
  
)

export default component.exports